/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Wrapper model around the URL of a case image (such as an infographic or a clients form background).
 */
export interface CaseImageModel { 
    /**
     * URL of the image, null if not defined.
     */
    url: string | null;
}

